var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 141.7 141.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M99.5 54.8V37l-19-17.4H23.2c-2 0-3.7 1.6-3.7 3.7V118c0 2 1.6 3.7 3.7 3.7h72.6c2 0 3.7-1.6 3.7-3.7v-5.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M80.5 19.7V37h19M116.9 103H60.8c-2.8 0-5.1-2.3-5.1-5.1V69c0-2.8 2.3-5.1 5.1-5.1h56.1c2.8 0 5.1 2.3 5.1 5.1v28.8c0 2.9-2.3 5.2-5.1 5.2zM100.1 77h11.7M93.8 77.1L84.3 90M84.3 77.1L93.8 90M105.9 77.9v12.2M66.7 77h11.7M72.5 77.9v12.2M33.7 49.8h16.8M33.7 41h20.5M33.3 32.6h21.1M58.5 43.6l8.1-8.3 4 3.6-8.4 8.4M55.8 46.5l-.1 3.2h3.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.ec37dff588d442589562d46ed5a3eb5f.svg";
export { ForwardRef as ReactComponent };